import iconBack from 'icons/caret.svg';
import isIE11 from 'utils/isIE11';

const styles = ({ links, typography }) => ({
  '&::before': {
    '&:hover': {
      background: isIE11 ? 'transparent' : links.link.hoverColor,
      color: links.link.hoverColor,
    },
    background: isIE11 ? 'transparent' : links.link.color,
    color: links.link.color,
    content: isIE11 ? '"< "' : '" "',
    height: isIE11 ? 'auto' : 24,
    left: isIE11 ? 'auto' : 0,
    maskImage: isIE11 ? 'none' : `url(${iconBack})`,
    position: isIE11 ? 'static' : 'absolute',
    top: isIE11 ? 'auto' : 7,
    transform: isIE11 ? 'none' : 'rotate(90deg)',
    width: isIE11 ? 'auto' : 24,
  },
  '&:hover': {
    color: links.link.hoverColor,
  },
  background: 'transparent none',
  border: 'none',
  borderRadius: 0,
  color: links.link.color,
  fontFamily: typography.p.fontFamily,
  left: '1%',
  paddingLeft: isIE11 ? 0 : 24,

  /* IE11 does not support masking, so fall back to plain text */
  position: 'absolute',
  top: '5.5%',
});

export default styles;
